/**
 * <s-random-pick count="5"> — Random Pick Web Component
 * Shows a random selection of the list items it wraps, so every visit gets a
 * different set. Liquid renders a pool of items with only the first `count`
 * visible, which keeps a sensible fallback when JavaScript doesn't run.
 */
class SRandomPick extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('ul, ol');
    if (!list) return;
    const items = Array.from(list.children);
    const count = Math.max(1, parseInt(this.getAttribute('count') ?? '5', 10) || 5);
    if (items.length <= count) return;

    // Fisher–Yates shuffle of the pool.
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]];
    }

    items.forEach((item, index) => {
      item.hidden = index >= count;
      list.appendChild(item);
    });

    // Let a wrapping carousel recompute its arrows now that the visible set changed.
    list.dispatchEvent(new Event('scroll'));
  }
}

if (!customElements.get('s-random-pick')) customElements.define('s-random-pick', SRandomPick);
